import { createApp } from 'vue';
import App from './App.vue';
import Vue3Lottie from 'vue3-lottie';
import InlineSvg from 'vue-inline-svg';
import './assets/scss/app.scss';

const appElement = document.getElementById('app');
const rawData = appElement.getAttribute('data-data');
const isRecipe = appElement.hasAttribute('data-isRecipe');
let initialData = {};

try {
    initialData = rawData ? JSON.parse(rawData) : {};
} catch (error) {
    console.error('Error parsing initial data:', error);
}

createApp(App, {
    initialData: initialData,
    isRecipe: isRecipe
})
    .use(Vue3Lottie)
    .component('inline-svg', InlineSvg)
    .mount('#app');